var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "twitter",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.24 102.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1da1f2}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter-original") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "original",
    className: "cls-1",
    d: "M40.58 115.3c47.64 0 73.69-39.47 73.69-73.69 0-1.12 0-2.24-.07-3.35a52.7 52.7 0 0 0 12.92-13.41 51.7 51.7 0 0 1-14.87 4.08 26 26 0 0 0 11.38-14.33 51.9 51.9 0 0 1-16.45 6.29 25.92 25.92 0 0 0-44.13 23.62A73.53 73.53 0 0 1 9.67 17.45a25.92 25.92 0 0 0 8 34.58A25.71 25.71 0 0 1 6 48.78v.33A25.91 25.91 0 0 0 26.73 74.5a25.86 25.86 0 0 1-11.7.44 25.93 25.93 0 0 0 24.2 18A52 52 0 0 1 7.06 104a52.72 52.72 0 0 1-6.18-.36 73.32 73.32 0 0 0 39.7 11.63",
    transform: "translate(-.88 -12.7)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOriginal);
export default __webpack_public_path__ + "static/media/TwitterOriginal.0935bffdda15c842bb2f10330645090e.svg";
export { ForwardRef as ReactComponent };